// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"10":"tsub-middleware","50":"ajs-destination","104":"schemaFilter","248":"auto-track","440":"datadogProfiler","521":"remoteMiddleware","538":"queryString","581":"datadogRecorder","694":"legacyVideos"}[chunkId] || chunkId) + ".js";
};